import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { Panel, Tab, Nav, Row, Col, NavItem, NavDropdown, MenuItem } from 'react-bootstrap';
import * as Actions from 'actions';
import { FileUploader, InfoWidget } from '../';
import { Map, Marker, InfoWindow, Feature, DataLayer } from 'google-react-maps';
import { getIconForClient } from 'utils';

class ClientIncident extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      incident: {
        damage_level: '',
        material_type: '',
        adjuster: '',
        description: '',
        storm: ''
      }
    }
  }

  // When component mounts, check current state to see if we already have this incident loaded, otherwise query it.
  componentWillMount() {
    let incident = this.props.client_incidents.incidents.find((incident, idx) => {
      return incident._id == this.props.params.incident;
    });

    if (this.props.incident) {
      return this.setState({ incident: this.props.incident });
    }

    if (!incident) {
      this.props.fetchIncident(this.props.params.incident);
    }

    if (incident) {
      this.setState({ incident });
    }
  }

  // When our client_incidents state changes and we have no incident, add it to state.
  // This is for those cases where we have queried it because we didn't have it in state already.
  componentWillUpdate(nextState, nextProps) {
    if (!this.state.incident || !this.state.incident._id) {
      this.setState({
        incident: this.props.client_incidents.incidents.find((incident, idx) => {
          return incident._id == this.props.params.incident;
        })
      });
    }
  }

  render() {
    let damageLevelColor;

    switch(this.state.incident.damage_level) {
      case 'Light':
        damageLevelColor = 'green'
        break;
      case 'Moderate':
        damageLevelColor = 'orange'
        break;
      case 'Severe':
        damageLevelColor = 'red';
        break;
      default:
        damageLevelColor = '';
        break;
    }

    const client = this.props.client;

    const longitude = client.address.feature.geometry.coordinates[0];
    const latitude = client.address.feature.geometry.coordinates[1];
    const mapTitle = this.state.incident.storm.properties ? this.state.incident.storm.properties.title : '';
    const mapFeatures = this.state.incident.storm.features ? this.state.incident.storm.features : [];
    const mapProperties = this.state.incident.storm.properties ? this.state.incident.storm.properties : {};

    return (
      <div>
        <div className="row">
          <div className="col-xs-12 col-md-4 col-lg-4 col-xl-4">
            <InfoWidget title='Damage Level' text={this.state.incident.damage_level} icon='fa fa-bolt' iconBgColor={damageLevelColor} />
          </div>
          <div className="col-xs-12 col-md-4 col-lg-4 col-xl-4">
            <InfoWidget title='Material Type' text={this.state.incident.material_type} icon='fa fa-info' />
          </div>
          <div className="col-xs-12 col-md-4 col-lg-4 col-xl-4">
            <InfoWidget title='Adjuster' text={this.state.incident.adjuster} icon='fa fa-user-circle-o' />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <section className="panel">
              <header className="panel-heading">
                <h2 className="panel-title"> <i className="fa fa-exclamation-triangle"></i> Incident Description</h2>
                <p className="panel-subtitle">Description of the incident</p>
              </header>
              <div className="panel-body">
                <p>
                  { this.state.incident.description }
                </p>
              </div>
            </section>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <section className="panel">
              <header className="panel-heading">
                <h2 className="panel-title"> <i className="fa fa-upload"></i> File Upload</h2>
                <p className="panel-subtitle">Attach pictures or documents to this damage incident </p>
              </header>
              <div className="panel-body">
                <p>
                  <FileUploader
                    endpoint={`/upload/incident/${this.state.incident._id}`}
                  />
                </p>
              </div>
            </section>
          </div>
          <div className="col-xs-12 col-md-6">
            <section className="panel">
              <header className="panel-heading">
                <h2 className="panel-title"> <i className="fa fa-folder"></i> Incident Files</h2>
                <p className="panel-subtitle"> Files related to this incident </p>
              </header>
              <div className="panel-body">
                <div className="row">
                  <div className="col-xs-1">
                    <i className="fa fa-file-pdf-o fa-4x"></i>
                  </div>
                  <div className="col-xs-1">
                    <i className="fa fa-file-word-o fa-4x"></i>
                  </div>
                  <div className="col-xs-1">
                    <i className="fa fa-file-text-o fa-4x"></i>
                  </div>
                  <div className="col-xs-1">
                    <i className="fa fa-file-excel-o fa-4x"></i>
                  </div>
                  <div className="col-xs-1">
                    <i className="fa fa-file-image-o fa-4x"></i>
                  </div>
                  <div className="col-xs-1">
                    <i className="fa fa-file-pdf-o fa-4x"></i>
                  </div>

                </div>
              </div>
            </section>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-8">
            <section className="panel">
              <header className="panel-heading">
                <h2 className="panel-title"><i className="fa fa-globe"></i> Incident Map - { mapTitle }</h2>
                <p className="panel-subtitle">View the storm that impacted the client</p>
              </header>
              <div className="panel-body">
                <Map api-key="AIzaSyCWuH5SGDikY4OPSrbJxqTi4Y2uTgQUggw"
                    optionsConstructor={function(maps) {
                      Object.assign(this, {
                        zoom : 23,
                        mapTypeId : maps.MapTypeId.ROADMAP,
                        disableDefaultUI: true,
                        zoomControl : true,
                        zoomControlOptions : {
                          position: maps.ControlPosition.LEFT_CENTER
                        },
                        keyboardShortcuts : true,
                        panControl: true,
                        panControlOptions : {
                          position : maps.ControlPosition.BOTTOM_RIGHT
                        },
                        mapTypeId : maps.MapTypeId.HYBRID,
                        mapTypeControl : true,
                        mapTypeControlOptions : {
                          position: maps.ControlPosition.RIGHT_TOP
                        },
                        fullscreenControlOptions : {
                          position: maps.ControlPosition.RIGHT_BOTTOM
                        },
                        fullscreenControl: true
                      });
                    }}
                    style={{position:"relative", top: 0, right: 0, left: 0, bottom : 0, height: '300px'}}>
                    <DataLayer zIndex={1} fillOpacity={0.5}>
                      {mapFeatures.map((f,i) => {
                          return <Feature
                            key={f._id ? f._id : f.properties._id}
                            // onClick={feature => {
                            //   this.handleFeatureClick(feature, item.map);
                            // }}
                            // onRightClick={this.handleMapClick}
                            editable={false}
                            id={f._id? f._id : f.properties._id}
                            geoJson={f} />
                          }
                        )}
                    </DataLayer>
                  <Marker icon={getIconForClient(client)} coords={{ lng: longitude, lat: latitude }}>
                    <InfoWindow open={true}>
                        <div>{client.name}</div>
                    </InfoWindow>
                  </Marker>
                </Map>
              </div>
            </section>
          </div>
          <div className="col-xs-12 col-md-4">
            <section className="panel">
              <header className="panel-heading">
                <h2 className="panel-title"> <i className="fa fa-bolt"></i> Storm Details</h2>
                <p className="panel-subtitle"></p>
              </header>
              <div className="panel-body">
                <ul className="list-unstyled">
                  <li><strong>Map Name: </strong>{mapProperties.title}</li>
                  <li><strong>Date: </strong>{moment(mapProperties.storm_date).format('YYYY-MM-DD')}</li>
                  <li><strong>Max Wind Speed: </strong> {`${mapProperties.max_wind_speed || 'N/A'} mph` || 'N/A'}</li>
                  <li><strong>Max Hail Size: </strong> {mapProperties.max_hail_size || 'N/A'} in.</li>
                  <li><strong>Max House Count: </strong> {mapProperties.max_house_count || 'N/A'}</li>
                  <li><strong>Isolated: </strong> {mapProperties.hail_isolated || 'N/A'}</li>
                </ul>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

ClientIncident.propTypes = {
  client : PropTypes.object
}

const mapStateToProps = ({ client, client_incidents }) => ({ client, client_incidents });

export default connect(mapStateToProps, Actions)(ClientIncident);



// WEBPACK FOOTER //
// ./src/browser/components/client/client-incident.js